export default "__VITE_ASSET__Ck8mowy9__"